import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import propTypes from '@/components/Form/propTypes'

import './index.scss'

import DatePicker from 'react-datepicker'
import styled from 'styled-components'

import { withField } from '@/components/Form/FieldWrappers/withField'

const StyledDatePickerContainer = styled.div`
  && {
    ${({ showIcon }: any) =>
      showIcon &&
      `
          input {
              padding: 12px;
              border: 1px solid rgb(209 213 219 / 1);
              border: 1px solid rgb(209 213 219 / 1);
              outline: none;
              width: 100%;
              border-radius: 0.375rem;
              overflow-y: auto;
              color: var(--wg-grey);
              background-repeat: no-repeat;
              background-size: 25px 25px;
              background-position: 98% 50%;
              background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+aWNfZXZlbnRfNDhweDwvdGl0bGU+CiAgICA8ZyBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIiBmaWxsPSIjNTk1OTU5Ij4KICAgICAgICA8cGF0aCBkPSJNMzQgMjRIMjR2MTBoMTBWMjR6TTMyIDJ2NEgxNlYyaC00djRoLTJjLTIuMjEgMC0zLjk4IDEuNzktMy45OCA0TDYgMzhjMCAyLjIxIDEuNzkgNCA0IDRoMjhjMi4yMSAwIDQtMS43OSA0LTRWMTBjMC0yLjIxLTEuNzktNC00LTRoLTJWMmgtNHptNiAzNkgxMFYxNmgyOHYyMnoiLz4KICAgIDwvZz4KPC9zdmc+');
            }
        `}
  }
`

const WorkflowDateTimePicker = ({
  className,
  style,
  name,
  onChange,
  value,
  showTimeOnly,
  showMonthYearPicker = false,
  showTimeSelect = true,
  placeholderText = '',
  showIcon = false,
  dateFormat = 'MM/dd/yyyy h:mm aa',
  readOnly = false
}: any) => {
  return (
    // @ts-expect-error
    <StyledDatePickerContainer className={className} showIcon={showIcon} style={style}>
      <DatePicker
        disabled={readOnly}
        // @ts-expect-error
        style={{ borderRadius: '5px' }}
        selected={(value && new Date(value)) || null}
        onChange={(val: any) => {
          onChange(name, val)
        }}
        className="custom-input"
        showTimeSelect={showTimeSelect}
        showMonthYearPicker={showMonthYearPicker}
        showTimeSelectOnly={showTimeOnly}
        timeInputLabel="Time:"
        placeholderText={placeholderText}
        dateFormat={dateFormat}
      />
    </StyledDatePickerContainer>
  )
}

WorkflowDateTimePicker.displayName = 'WorkflowDateTimePicker'

WorkflowDateTimePicker.propTypes = {
  ...propTypes,
  /**
   * optional callback for each date visible in a picker to determine if it's a valid selection or not. function takes
   * arguments of `currentDate`, which is the date to validate, and `selectedDate`, the already selected value in the
   * picker, and must return a boolean
   */
  isValid: PropTypes.func,
  /**
   * Whether the time field should be shown by default
   */
  includeTime: PropTypes.bool
}

WorkflowDateTimePicker.defaultProps = {
  ...defaultProps,
  isValid: () => true,
  includeTime: false
}

export default withField(WorkflowDateTimePicker)
